<template>
  <div class='radio-container'>
    <input
      type='radio'
      :name='name'
      ref='radioInput'
      :id='id'
      :required='required'
      :disabled='disabled'
      :value='value'
      :checked='value === selectedValue'
      @change='updateValue'/>

    <label v-if='label' class='font-smoothing' :for='id'>
      <span v-if='useSpan'>{{ label }}</span>
      <template v-else>{{ label }}</template>
    </label>

    <label v-else-if='labelAsSlot' class='font-smoothing' :for='id'>
      <slot name='label'></slot>
    </label>
  </div>
</template>

<script>
  let radioId = 0

  export default {
    name: 'x-radio-button',
    props: {
      value: {
        required: true
      },

      label: {
        type: String,
        default: null
      },

      labelAsSlot: {
        type: Boolean,
        default: false
      },

      required: {
        type: Boolean,
        default: false
      },

      disabled: {
        type: Boolean,
        default: false
      },

      selectedValue: {
        required: true
      },

      useSpan: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      updateValue () {
        this.$parent.updateValue(this.value)
      }
    },

    computed: {
      name () {
        const { $parent } = this
        return $parent && $parent.id
      }
    },

    data () {
      return {
        id: `x-radio-button-${radioId++}`
      }
    }
  }
</script>

<style lang='scss' scoped rel='stylesheet/scss'>
  .radio-container {
    display: inline-block;
  }
</style>
